// Configuration API
const API_BASE_URL = import.meta.env.VITE_REACT_APP_API_EP_URI;

export interface VerifyTicketResult {
  status: string;
  user_id: number;
  login: string;
  firstname: string | null;
  lastname: string | null;
  gitlab_username: string | null;
  access_token: string;
  refresh_token: string;
}

class StudentRegistrationService {

  async getCasLoginUrl(): Promise<string> {
    const response = await fetch(`${API_BASE_URL}/student-registration/cas-login-url`);
    const json = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(json.message || `HTTP error! status: ${response.status}`);
    }
    return json.url;
  }

  async verifyTicket(ticket: string): Promise<VerifyTicketResult> {
    const response = await fetch(`${API_BASE_URL}/student-registration/verify-ticket?ticket=${encodeURIComponent(ticket)}`);
    const json = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(json.message || `HTTP error! status: ${response.status}`);
    }
    return json;
  }

  async completeRegistration(gitlabUsername: string, accessToken: string): Promise<{ message: string; gitlab_username: string }> {
    const response = await fetch(`${API_BASE_URL}/student-registration/complete`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
      body: JSON.stringify({ gitlab_username: gitlabUsername }),
    });
    const json = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(json.message || `HTTP error! status: ${response.status}`);
    }
    return json;
  }
}

export const studentRegistrationService = new StudentRegistrationService();
